var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"field-group"},[_c('b-col',[_c('ListingMatching',{attrs:{"name":"newGame","list":_vm.matchingResults}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }